export default {"src":"/_next/static/media/plants.048e27ff.svg","height":30,"width":26,"blurWidth":0,"blurHeight":0};